"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var apiUtil = require('../util/api');
var apiName = 'Motusi';
module.exports = function (API) {
    var _a = apiUtil(API), paginateRequest = _a.paginateRequest, getPrograms = _a.getPrograms, getProgramDetail = _a.getProgramDetail, getSpacesForUser = _a.getSpacesForUser, getMotionMarks = _a.getMotionMarks;
    var retrieveUserDatasetInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
        var personalPrograms, spacePrograms, programs, movements, datasets;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, getPrograms()];
                case 1:
                    personalPrograms = _a.sent();
                    return [4, findSpacePrograms()];
                case 2:
                    spacePrograms = _a.sent();
                    programs = personalPrograms.concat(spacePrograms).flat();
                    return [4, Promise.all(programs.map(function (p) { return __awaiter(void 0, void 0, void 0, function () {
                            var prog;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4, getProgramDetail(p.id)];
                                    case 1:
                                        prog = _a.sent();
                                        if (!prog) {
                                            return [2, []];
                                        }
                                        return [2, prog.movements.map(function (e) {
                                                return {
                                                    label: p.name + "-" + e.name + "-",
                                                    programId: p.id,
                                                    programName: p.name,
                                                    isAssessment: p.isAssessment,
                                                    movementId: e.id,
                                                    movementName: e.name,
                                                };
                                            })];
                                }
                            });
                        }); }))];
                case 3:
                    movements = _a.sent();
                    return [4, Promise.all(movements.flat().map(function (e) { return __awaiter(void 0, void 0, void 0, function () {
                            var datasetsResponse;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4, getAllDatasetsForMovement(e.movementId)];
                                    case 1:
                                        datasetsResponse = _a.sent();
                                        return [2, datasetsResponse.map(function (dataset) { return (__assign(__assign(__assign({}, dataset), e), { label: e.label + dataset.processedAt })); })];
                                }
                            });
                        }); }))];
                case 4:
                    datasets = _a.sent();
                    return [2, datasets.flat()];
            }
        });
    }); };
    var downloadDataset = function (datasetId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, datasetResult, data, marks, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, API.get(apiName, "/datasets/" + datasetId + "/file")];
                case 1:
                    response = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 6, , 7]);
                    return [4, fetch(response.signedUrl, {
                            method: 'GET',
                        })];
                case 3:
                    datasetResult = _a.sent();
                    return [4, datasetResult.json()];
                case 4:
                    data = _a.sent();
                    return [4, paginateRequest(getMotionMarks.bind(null, datasetId))];
                case 5:
                    marks = (_a.sent()) || [];
                    data.dataset.timelineTags = marks;
                    return [2, data];
                case 6:
                    err_1 = _a.sent();
                    console.error('fetch-dataset-error', err_1);
                    return [3, 7];
                case 7: return [2];
            }
        });
    }); };
    function getAllDatasetsForMovement(id, start, limit) {
        if (start === void 0) { start = 1; }
        if (limit === void 0) { limit = 20; }
        return __awaiter(this, void 0, void 0, function () {
            var url, result, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = "/programs/movements/" + id + "/datasets?page=" + start + "&limit=" + limit;
                        return [4, API.get(apiName, url)];
                    case 1:
                        result = _c.sent();
                        if (!(result.data.length >= limit)) return [3, 3];
                        _b = (_a = result.data).concat;
                        return [4, getAllDatasetsForMovement(id, ++start)];
                    case 2: return [2, _b.apply(_a, [_c.sent()])];
                    case 3: return [2, result.data];
                }
            });
        });
    }
    function findSpacePrograms() {
        return __awaiter(this, void 0, void 0, function () {
            var complexSpaces, spaces, spacePrograms;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, getSpacesForUser()];
                    case 1:
                        complexSpaces = _a.sent();
                        spaces = complexSpaces.map(function (e) {
                            return __assign({}, e.space);
                        });
                        return [4, Promise.all(spaces.map(function (e) { return __awaiter(_this, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4, API.get(apiName, "/spaces/" + e.id + "/programs", {
                                                queryStringParameters: {},
                                            })];
                                        case 1:
                                            result = _a.sent();
                                            return [2, result.data];
                                    }
                                });
                            }); }))];
                    case 2:
                        spacePrograms = _a.sent();
                        return [2, spacePrograms];
                }
            });
        });
    }
    return {
        retrieveUserDatasetInfo: retrieveUserDatasetInfo,
        downloadDataset: downloadDataset,
    };
};
//# sourceMappingURL=retrieve-datasets-for-profile.js.map